import { stringify } from 'query-string';
import { WEB_PAGE } from '../constants/index.js';
const evokeByThirdParty = params => Promise.resolve(window.open(`${WEB_PAGE}/portkey-download?${stringify(params)}`));
export default evokeByThirdParty;
